import React, {Component} from "react";
import {connect} from "react-redux";
import ProductsTable from "../../../../domain/components/products/ProductsTable";
import ProductsTableDemo from "../../../../domain/components/products/ProductsTableDemo";
import {Authorizations, hasAuthorization} from "../../../../utils/authorizations";

class MarketPlaceProductsTables extends Component {
    render() {
        const {authorizations} = this.props;
        const offer = 'marketPlace';
        if (hasAuthorization(authorizations, Authorizations.GLOBAL_DEMO)) {
            return <ProductsTableDemo match={this.props.match} history={this.props.history} offer={offer}/>

        } else {
            return <ProductsTable match={this.props.match} history={this.props.history} offer={offer}/>

        }
    }
}

const mapStateToProps = (state) => {
    return {
        authorizations: state.authentication.authorizations,
    };
};

export default connect(mapStateToProps)(MarketPlaceProductsTables);
